import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { LayerListId } from '../components/map/layer-list/layer-list.model';

export interface LayerListSubject {
  selected: LayerListId[];
  newSelected?: LayerListId;
  type?: 'add' | 'remove';
}

@Injectable({
  providedIn: 'root'
})
export class LayerListService {
  public layerSelected = new BehaviorSubject<LayerListSubject>({
    selected: []
  });
  get selected() {
    return this.layerSelected.value.selected;
  }
  constructor() { }

  add(layerId: LayerListId) {
    // nếu đã tồn tại rồi thì bỏ qua
    if (this.selected.indexOf(layerId) > - 1) {
      return;
    }
    const afterAdd = [...this.selected];
    afterAdd.push(layerId);
    this.layerSelected.next({ selected: afterAdd, newSelected: layerId, type: 'add' });
    // nếu nền vệ tinh thì ẩn nền đường phố và ngược lại
    if (layerId === LayerListId.NenVeTinh) {
      this.remove(LayerListId.NenDuongPho);

    } else if (layerId === LayerListId.NenDuongPho) {
      this.remove(LayerListId.NenVeTinh);
    }

    // nếu hiển thị tài nguyên môi trường thì không hiển thị quy hoạch xây dựng và ngược lại
    if (layerId === LayerListId.QuyHoachSDD) {
      this.remove(LayerListId.SDDTaiNguyenMoiTruong);
    } else if (layerId === LayerListId.SDDTaiNguyenMoiTruong) {
      this.remove(LayerListId.QuyHoachSDD);
    }
  }

  remove(layerId: LayerListId) {

    const index = this.selected.indexOf(layerId);

    if (index > -1) {
      const afterRemove = [...this.selected];
      afterRemove.splice(index, 1);
      // nếu hủy chọn nền vệ tinh hoặc hủy chọn nền đường phố
      // phải đảm bảo ít nhất tồn tại nền vệ tinh hoặc nền đường phố
      if (
        [LayerListId.NenVeTinh, LayerListId.NenDuongPho].indexOf(layerId) > -1
        && afterRemove.indexOf(LayerListId.NenVeTinh) === -1
        && afterRemove.indexOf(LayerListId.NenDuongPho) === -1) {
        return;
      }
      // phải đảm bảo ít nhất tồn tại nền sử dụng đất
      if ([LayerListId.SDDTaiNguyenMoiTruong, LayerListId.QuyHoachSDD].indexOf(layerId) > -1
        && afterRemove.indexOf(LayerListId.SDDTaiNguyenMoiTruong) === -1
        && afterRemove.indexOf(LayerListId.QuyHoachSDD) === -1
      ) {
        return;
      }
      this.layerSelected.next({ selected: afterRemove, newSelected: layerId, type: 'remove' });
    }
  }
}
